<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    size: {
      type: Number,
      default: () => 70,
    },
    width: {
      type: Number,
      default: () => 7,
    },
    center: {
      type: Boolean,
      default: () => true,
    },
  },
});
</script>

<template>
  <div :class="center ? 'text-xs-center': ''">
    <v-progress-circular
      :size="size"
      :width="width"
      color="primary"
      indeterminate
    />
  </div>
</template>
